import React from "react";
import { ensure, GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { ensureTvSeriesContentSubtype } from "../../../../../common/types/TvSeriesContentSubtype";
import { FileRecordDetails } from "../../FileRecordDetails";
import { FileRecordTvSeriesVersionInfo } from "./FileRecordTvSeriesVersionInfo";

interface FileRecordTvSeriesContentViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordTvSeriesContentView = ({
    fileRecordDetails
}: FileRecordTvSeriesContentViewProps): JSX.Element => {
    ensure(fileRecordDetails.content);
    ensureTvSeriesContentSubtype(fileRecordDetails.content.contentSubtype);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={fileRecordDetails.content.tvSeries.name}
                        testId="tvSeries-title-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[fileRecordDetails.content.contentSubtype]}
                        testId="tvSeries-content-type-field"
                    />
                    <LabeledText
                        label="Season"
                        value={fileRecordDetails.content.season?.name ?? "-"}
                        testId="tvSeries-season-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Episode"
                        value={fileRecordDetails.content.episode?.name ?? "-"}
                        testId="tvSeries-episode-field"
                        textTooltip
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <FileRecordTvSeriesVersionInfo
                        tvSeriesId={fileRecordDetails.content.tvSeries.id}
                        versionIds={fileRecordDetails.content.versions.map((v) => v.id)}
                        episodeId={fileRecordDetails.content.episode?.id}
                        seasonId={fileRecordDetails.content.season?.id}
                    />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
